import React from 'react';
import { CustomHeroButton, Typography } from '../../../../components';

interface DepositWarningBannerProps {
  minimumDeposit: number;
  onDepositClick: () => void;
  t: (key: string, params?: any) => string;
}

const DepositWarningBanner: React.FC<DepositWarningBannerProps> = ({
  minimumDeposit,
  onDepositClick,
  t,
}) => {
  return (
    <div className="flex flex-col gap-6 w-full">
      <Typography variant="h6" className="font-medium text-auth-ink">
        {t('revshare.depositBanner.title')}
      </Typography>

      <div className="border border-neutral-200 rounded-br-3 rounded-tr-3 overflow-hidden">
        <div className="bg-neutral-50 border-l-[0.1875rem] border-partner p-4 flex flex-col gap-6">
          <div className="flex gap-4 items-start">
            {/* Icon */}
            <div className="bg-husky border border-[rgba(0,81,188,0.2)] rounded-[1.875rem] p-2.5 flex items-center justify-center shrink-0">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 1.33334C4.32 1.33334 1.33334 4.32 1.33334 8C1.33334 11.68 4.32 14.6667 8 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8C14.6667 4.32 11.68 1.33334 8 1.33334ZM8 11.3333C7.63334 11.3333 7.33334 11.0333 7.33334 10.6667V8C7.33334 7.63334 7.63334 7.33334 8 7.33334C8.36667 7.33334 8.66667 7.63334 8.66667 8V10.6667C8.66667 11.0333 8.36667 11.3333 8 11.3333ZM8.66667 6H7.33334V4.66667H8.66667V6Z"
                  fill="#006FEE"
                />
              </svg>
            </div>

            {/* Text Content */}
            <div className="flex flex-col gap-0.5 flex-1">
              <Typography variant="body2" className="font-medium text-partner">
                {t('revshare.depositBanner.subtitle')}
              </Typography>
              <div className="text-zinc-500 text-sm font-normal leading-5 space-y-2">
                <p>
                  {t('revshare.depositBanner.description.part1')}{' '}
                  <span className="font-medium text-auth-ink">${minimumDeposit}</span>
                </p>
                <p>{t('revshare.depositBanner.description.part2')}</p>
                <p>{t('revshare.depositBanner.description.part3')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CustomHeroButton
        className="!bg-primary !text-white w-fit"
        onPress={onDepositClick}
        title={t('revshare.depositBanner.action')}
      />
    </div>
  );
};

export default DepositWarningBanner;
